import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/cns-parametrizacao`

    return {
        index() {
            return repository.get(`${baseUrl}`)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        destroy() {
            return repository.delete(`${baseUrl}`)
        },
        download() {
            return repository.get(`${baseUrl}/download`, {responseType: 'arraybuffer'})
        },
    }
}